import { Dispatch } from "redux";
import {
  getHolidays,
  createHoliday,
  updateHoliday,
  deleteHoliday,
} from "../../services/HolidayService";
import { Holiday } from "../../types/Holiday";

// Action Types
export enum HolidayActionType {
  FETCH_HOLIDAYS = "FETCH_HOLIDAYS",
  ADD_HOLIDAY = "ADD_HOLIDAY",
  EDIT_HOLIDAY = "EDIT_HOLIDAY",
  DELETE_HOLIDAY = "DELETE_HOLIDAY",
}

// Action Interfaces
export interface FetchHolidayAction {
  type: HolidayActionType.FETCH_HOLIDAYS;
  data: Holiday[];
}

export interface AddHolidayAction {
  type: HolidayActionType.ADD_HOLIDAY;
  data: Holiday;
}

export interface EditHolidayAction {
  type: HolidayActionType.EDIT_HOLIDAY;
  data: Holiday;
}

export interface DeleteHolidayAction {
  type: HolidayActionType.DELETE_HOLIDAY;
  data: number;
}

export type HolidayAction =
  | FetchHolidayAction
  | AddHolidayAction
  | EditHolidayAction
  | DeleteHolidayAction;

// Thunks
export const fetchHolidays = () => async (dispatch: Dispatch) => {
  const data = await getHolidays();
  dispatch<FetchHolidayAction>({
    type: HolidayActionType.FETCH_HOLIDAYS,
    data,
  });
};

export const addHoliday = (holiday: Holiday) => async (dispatch: Dispatch) => {
  const response = await createHoliday(holiday);
  dispatch<AddHolidayAction>({
    type: HolidayActionType.ADD_HOLIDAY,
    data: response.data.data,
  });
};

export const editHoliday =
  (id: number, holiday: Holiday) => async (dispatch: Dispatch) => {
    const response = await updateHoliday(id, holiday);
    dispatch<EditHolidayAction>({
      type: HolidayActionType.EDIT_HOLIDAY,
      data: response.data.data,
    });
  };

export const deleteHolidayById = (id: number) => async (dispatch: Dispatch) => {
  await deleteHoliday(id);
  dispatch<DeleteHolidayAction>({
    type: HolidayActionType.DELETE_HOLIDAY,
    data: id,
  });
};
